import React, { Component } from 'react';

import KeyboardsSwitcher from './components/KeyboardsSwitcher';
import Time from './components/Time';
import PageNumber from './components/PageNumber';
import PhotoWrapper from './components/PhotoWrapper';
import TestVariant from './components/TestVariant';
import FileBase64 from 'react-file-base64';


//import numberKeySet from ''

var Loading = React.createClass({
  getInitialState: function(){
    return {
      text: '.'
    }
  },
  componentDidMount: function(){
    this.timer = setInterval(()=>{
      if(this.state.text == '.'){
        this.setState({text: '..'})
      }else if(this.state.text == '..'){
        this.setState({text: '...'})
      }else if(this.state.text == '...'){
        this.setState({text: '.'})
      }
    }, 500)
  },
  render: function(){
    return (
      <span>{this.state.text}</span>
    )
  },
  componentWillUnmount: function(){
    clearInterval(this.timer)
  }
})

var InfoComponent = React.createClass({
  render: function(){
    return (
      <b style={{marginLeft: 10}}>
        <div onClick={(e)=>{e.stopPropagation(); this.props.onClick();}} className="infoIcon"></div>
      </b>
    )
  }
})

var AlertComponent = React.createClass({
  render: function(){
    if(this.props.alert && !this.props.alertStatus){
      return (
        <div style={this.props.style || {}} className="alert" onClick={this.props.setAlertStatus}>
          <div className="wrapper" dangerouslySetInnerHTML={{__html: this.props.alert}}></div>
          <div style={{borderTop: '1px solid #ccc', textAlign: 'center', width: '100%', fontSize: 17, color: '#7d7d7d', padding: '4px 0 5px 0'}}>Для закрытия нажми на меня или начни печатать!</div>
        </div>
      )
    }else{
      return null
    }
  }
})

var KeyboardWrapper = React.createClass({
  onClickEtemForHeader: function(){
    this.props.setAlertStatus(false)
  },
  componentDidMount: function(){
    
    this.props.focusKeyboard();
    this.minusSizeInputTest();
    this.minusSizeInput();
  },
  minusSizeInputTest: function(){
    if(this.testInput && this.testInputWrapper && this.testInput.clientHeight > this.testInputWrapper.clientHeight){
      var newSize = this.testInputWrapper.style.fontSize.match(/\d\d/)[0] - 1 + 'px';
      this.testInputWrapper.style.fontSize = newSize;
      this.minusSizeInputTest();
    }
  },
  minusSizeInput: function(){
    
    if(this.input && this.inputWrapper && this.input.clientWidth > this.inputWrapper.clientWidth){
      var newSize = this.inputWrapper.style.fontSize.match(/\d\d/)[0] - 1 + 'px';
      this.inputWrapper.style.fontSize = newSize;
      this.minusSizeInput();
    }
  },
  handleBack: function(){
		this.props.actionSaveField({nav: 'back'});
  },  
  handleNext: function(){
    if (this.props.text !== null && this.props.text.length > 0 && this.props.regexp.test(this.props.text)) {
      
      if(this.props.nameField == 'city' || this.props.nameField == 'street' || this.props.nameField == 'numberHouse'){
        if( (this.props.text ? this.props.helper != "" && this.props.helper != "ERROR" : true) || new RegExp(this.props.text, 'i').test(this.props.helper) || (this.props.helper != '' ? new RegExp(this.props.helper, 'i').test(this.props.text) : false) ){
          this.props.actionSaveField({nav: 'next'});
        }else{
          this.props.actionSaveField({err: true});
          if(this.props.nameField == 'city'){
            this.props.setAlertStatus(false, 'Город не найден! При появлении верной подсказки Вы можете нажать - Далее.')
          }
          if(this.props.nameField == 'street'){
            this.props.setAlertStatus(false, 'Улица не найдена. При появлении верной подсказки Вы можете нажать - Далее, или пропустите этот шаг предварительно очистев поле.')
          }
          if(this.props.nameField == 'numberHouse'){
            this.props.setAlertStatus(false, 'Дом не найден. При появлении верной подсказки Вы можете нажать - Далее, или пропустите этот шаг предварительно очистев поле.')
          }
        }
      }else{
        this.props.actionSaveField({nav: 'next'});
      }
    }else if(this.props.emptyNext && (this.props.text !== null ? this.props.text.length == this.props.startText.length : true) && this.props.text == this.props.defaultText){
      this.props.actionSaveField({nav: 'next'});
    }else{
      this.props.actionSaveField({err: true});
      if(!this.props.text){
        this.props.setAlertStatus(false, 'Это обязательно поле!')
      }
    }
  },
  handleHome: function(){
    // this.props.actionSaveField({nav: 'home'});
    var result = confirm('Все данные сбросяться. Вы уверены?');
    if(result){
      this.props.reloadPage();
    }
  },
  handleDoneNext: function(data){
    if(this.props.regexp.test(data)){
      this.props.actionSaveField({
  			nav: 'next',
  			data: data
  		});
    }
  },
  actionSaveField: function(data, dop){
    this.props.setOpperativeKey({})
    if(this.props.showKeyboardFromTest){
      
      console.log('data', data)
      var newTest = {...this.props.test};

      newTest.answers = this.newArr;
  
      if(newTest.select){
        for (var i = 0, l = newTest.answers.length; i < l; i++) {
          if(newTest.answers[i].select){
            delete newTest.answers[i].select;
          }
        }
      }
  
      for(var i = 0, l = newTest.answers.length; i < l; i++){
        if(newTest.answers[i].customVariant){
          console.log('==', data == ' ')
          // if(data === ''){
          //   newTest.answers[i].name = newTest.answers[i].name.substring(0, newTest.answers[i].name.length - 1)
          // }else{
          //   newTest.answers[i].name += data;
          // }

          newTest.answers[i].name = data;

          newTest.answers[i].select = true;
          newTest.select = true;
  
          this.props.actionSaveField({
            newTest : newTest,
            // data    : cat,
            // nav     : 'next',
            test    : true
          })
  
        }
      }
    }else{
      if(dop && dop.type == 'video'){
        this.props.actionSaveField({
          video: dop.url
        });
      }

      this.props.actionSaveField({
        data: data
      });
      this.props.setAlertStatus(true)
    }
  },
  //поиск по ид нажатого пользователем варианта в массиве вариантов
  //проверка его на верность и
  //подсчет новых баллов
  handleTestSelect: function(data){

    var newTest = {...this.props.test};

    newTest.answers = this.newArr;

    if(newTest.select){
      for (var i = 0, l = newTest.answers.length; i < l; i++) {
        if(newTest.answers[i].select){
          delete newTest.answers[i].select;
        }
      }
    }

    for(var i = 0, l = newTest.answers.length; i < l; i++){
      if(data == newTest.answers[i].id){

        newTest.answers[i].select = true;
        newTest.select = true;

        this.props.actionSaveField({
          newTest : newTest,
          // data    : cat,
          nav     : 'next',
          test    : true
        })

      }
    }
  },
  handleTestBack: function(){
    this.props.actionSaveField({
      nav     : 'back',
      test    : true
    })
    if(this.props.showKeyboardFromTest){
      this.props.actionSelectCustomVariant();
    }
  },
  handleTestNext: function(){
    var cat = {...this.props.text},
        newTest = {...this.props.test};

    newTest.answers = this.newArr;

    this.props.actionSaveField({
      newTest : newTest,
      data    : cat,
      nav     : 'next',
      test    : true
    })

    if(this.props.showKeyboardFromTest){
      this.props.actionSelectCustomVariant();
    }
  },
  getInitialState: function(){
    return({sizeMin: false})
  },
  getFiles: function(files){
    // console.log(files);
    var size = parseInt(files.size);
    // console.log(size);
    if(size < 10000){
      this.setState({sizeMin: false})
      this.props.actionSaveField({data: files.base64});
    }else{
      this.setState({sizeMin: true})
    }

  },
  componentWillReceiveProps(nextProps) {
    if(JSON.stringify(nextProps.opperativeKey) !== JSON.stringify(this.props.opperativeKey)) {
      // console.log('nextProp.opperativeKey', nextProps.opperativeKey)
      if(nextProps.opperativeKey.keyCode == '13'){
        this.handleNext();
        this.props.setOpperativeKey({})
        return;
      }
    }
    var helper = nextProps.helper ? nextProps.helper : this.props.helper,
        text = nextProps.text ? nextProps.text : this.props.text;

    if(nextProps.nameField != this.props.nameField && nextProps.helper == '' && nextProps.text && (nextProps.nameField == 'city' || nextProps.nameField == 'street' || nextProps.nameField == 'numberHouse') ){
      console.log('вот тут запрос в яшу', nextProps)
      this.actionSaveField(nextProps.text);
    }
    if(this.props.nameField == 'city' || this.props.nameField == 'street' || this.props.nameField == 'numberHouse'){

      if(nextProps.helper == this.props.helper && nextProps.yandexTry != this.props.yandexTry && this.props.helper !== ''){
        
        if(!new RegExp(text, 'i').test(helper)){
          //console.log('ошииииибка', text, helper)
          this.props.actionSaveField({err: true});
        }else if(this.props.error){
          this.props.actionSaveField({err: false});
        }
      }

    }
    
  },
  componentDidUpdate: function(){
    if(this.testInputWrapper && this.testInput){
      this.testInputWrapper.style.fontSize = '32px';
      this.minusSizeInputTest();
    }
    if(this.inputWrapper && this.input){
      this.inputWrapper.style.fontSize = '36px';
      this.minusSizeInput();
    }
  },
  render: function(){
    if(this.props.typeWrapper == 'inputText'){
      var helper = '';
        if(this.props.helper && new RegExp(this.props.text, 'i').test(this.props.helper) && this.props.helper != 'ERROR'){
          //{helper}{helper ? (<span style={{color: '#ccc', textTransform: 'uppercase'}}>{helper}</span>) : this.props.text }
          helper = '<span style="color: #ccc; text-transform: uppercase">' + this.props.helper.replace(new RegExp(this.props.text, 'gi'), '<span style="color: #000">' + this.props.text + '</span>') + '</span>'
          //console.log(helper);
        }else{
          helper = this.props.text == 'ERROR' ? '' : this.props.text;
        }
      //првоерка на мобилку
      if(this.props.mobile){
        var showKeyboard = false;
        if(this.props.typeKeyboard == 'numbers' || this.props.typeKeyboard == 'letters' || this.props.typeKeyboard == 'letters2' || this.props.typeKeyboard == 'lettersLat' || this.props.typeKeyboard == 'numbersAndLetters' || this.props.typeKeyboard == 'numbersMoney' || this.props.typeKeyboard == 'NumbersAndLettersLat'){
          showKeyboard = true;
        }
        return(
          <div className={"formWrapper" + (this.props.error ? ' error' : '')}>
            <div className="header">
              <div className="wrapperTableCol">
                <div className="innerTable">
                <div className="back" onClick={this.handleBack}><i style={{verticalAlign: 'sub', fontSize: 25, position: 'relative', right: 9,}} className="fa fa-angle-left"></i> НАЗАД</div>
                  <PageNumber
                    pageID={this.props.pageID}
                  />
                  <div className="erase" onClick={this.handleNext}>ДАЛЕЕ <i style={{verticalAlign: 'sub', fontSize: 25, position: 'relative', left: 9,}} className="fa fa-angle-right"></i></div>
                </div>
              </div>
            </div>
            <div className="headline">
              <div className="namePage" style={{fontSize: this.props.nameSize}}><span className="textWrapper">{this.props.namePage}</span></div>
              <AlertComponent
                alert={this.props.alert}
                alertStatus={this.props.alertStatus}
                setAlertStatus={this.props.setAlertStatus}
              />
            </div>
            <div className="inputWrapper">
            <div className="input"><div className="input" dangerouslySetInnerHTML={{__html: helper}}></div></div>
            </div>
            <KeyboardsSwitcher
              type={this.props.typeKeyboard}
              actionSaveField={this.actionSaveField}
              regexp={this.props.regexp}
              defaultText={this.props.defaultText}
              text={this.props.text}
              actionDoneNext={this.handleDoneNext}
              autoNext={this.props.autoNext}
              mobile={this.props.mobile}
						  opperativeKey={this.props.opperativeKey}
              advertisingSites={this.props.advertisingSites}
            />
            {showKeyboard ? (
              <div className="keyboardButton">
                <input ref={(c) => this._input2 = c} style={{width: '100%', height: '100%', opacity: 0
                }} type="text" onFocus={function(){
                  // console.log('onFOCUUS1')
                  this.props.focusKeyboard();
                  this._input2.setAttribute("disabled", "disabled");
                }.bind(this)} />
            </div>
            ) : null}
            
          </div>
        );
      }else{
        
        return(
          <div className={"formWrapper" + (this.props.error ? ' error' : '')}>
            <AlertComponent
              alert={this.props.alert}
              alertStatus={this.props.alertStatus}
              setAlertStatus={this.props.setAlertStatus}
            />
            <div className="header" onClick={this.handleHome}>
              <div className="home"><i style={{fontSize: 32, position: 'relative', top: 6}} className="material-icons">&#xe5c3;</i> Главная</div>
              <div className="namePage" style={{fontSize: this.props.nameSize}}><span className="textWrapper">{this.props.namePage}{this.props.alert ? (<InfoComponent onClick={this.onClickEtemForHeader} />) : null}</span></div>
              <Time/>
            </div>
            <div className="inputWrapper">
              <div className="back" onClick={this.handleBack}><i style={{fontSize: 40, position: 'relative', top: 5, right: 9,}} className="fa fa-angle-left"></i> НАЗАД</div>
              <div className="input" ref={(c) => this.inputWrapper = c}><div ref={(c) => this.input = c} className="input children" dangerouslySetInnerHTML={{__html: helper}}></div></div>
              {this.props.loading ? (
                <div className="erase" >ЗАГРУЗКА <Loading /></div>
              ) : (
                <div className="erase" onClick={this.handleNext}>ДАЛЕЕ <i style={{fontSize: 40, position: 'relative', top: 5, left: 9,}} className="fa fa-angle-right"></i></div>
              )}
            </div>
            <KeyboardsSwitcher
              type={this.props.typeKeyboard}
              actionSaveField={this.actionSaveField}
              regexp={this.props.regexp}
              defaultText={this.props.defaultText}
              text={this.props.text}
              actionDoneNext={this.handleDoneNext}
              autoNext={this.props.autoNext}
              mobile={this.props.mobile}
              opperativeKey={this.props.opperativeKey}
              advertisingSites={this.props.advertisingSites}
            />
          </div>
        );
      }

    }else if(this.props.typeWrapper == 'inputPhoto'){
      if(this.props.mobile){
        return(
          <div className={"formWrapper photo" + (this.props.error ? ' error' : '')}>
            <AlertComponent
              alert={this.props.alert}
              alertStatus={this.props.alertStatus}
              setAlertStatus={this.props.setAlertStatus}
              style={{marginTop: 97}}
            />
            <div className="header">
              <div className="wrapperTableCol">
                <div className="innerTable">
                  <div className="back" onClick={this.handleBack}><i style={{verticalAlign: 'sub', fontSize: 25, position: 'relative', right: 9,}} className="fa fa-angle-left"></i> НАЗАД</div>
                  <PageNumber
                    pageID={this.props.pageID}
                  />
                  {this.props.loading ? (
                    <div className="erase" >ЗАГРУЗКА <Loading /></div>
                  ) : (
                    <div className="erase" onClick={this.handleNext}>ДАЛЕЕ <i style={{verticalAlign: 'sub', fontSize: 25, position: 'relative', left: 9,}} className="fa fa-angle-right"></i></div>
                  )}
                  
                </div>
              </div>
            </div>

            <div className="keyboardWrapper">
              <PhotoWrapper
                actionSaveField={this.actionSaveField}
                photo={this.props.text}
                name={this.props.nameField}
                mobile={this.props.mobile}
                unicPhoto={this.props.unicPhoto}
              />
            </div>
          </div>
        );
      }else{
        return(
          <div className="formWrapper photo">
            <AlertComponent
              alert={this.props.alert}
              alertStatus={this.props.alertStatus}
              setAlertStatus={this.props.setAlertStatus}
            />
            <div className="header" onClick={this.handleHome}>
            <div className="home" onClick={this.handleHome}><i style={{fontSize: 32, position: 'relative', top: 6}} className="material-icons">&#xe5c3;</i>Главная</div>
              <div className="namePage" style={{fontSize: this.props.nameSize}}><span className="textWrapper">{this.props.namePage}{this.props.alert ? (<InfoComponent onClick={this.onClickEtemForHeader} />) : null}</span></div>
              <Time/>
            </div>
            <div className="inputWrapper">
            <div className="back" onClick={this.handleBack}><i style={{fontSize: 40, position: 'relative', top: 5, right: 9,}} className="fa fa-angle-left"></i> НАЗАД</div>
            {this.props.loading ? (
              <div className="erase" >ЗАГРУЗКА <Loading /></div>
            ) : (
              <div className="erase" onClick={this.handleNext}>ДАЛЕЕ <i style={{fontSize: 40, position: 'relative', top: 5, left: 9,}} className="fa fa-angle-right"></i></div>
            )}
            
            </div>
            <div className="keyboardWrapper">
              <PhotoWrapper
                actionSaveField={this.actionSaveField}
                photo={this.props.text}
                name={this.props.nameField}
                mobile={this.props.mobile}
                unicPhoto={this.props.unicPhoto}
              />
            </div>
          </div>
        );
      }
    }else if(this.props.typeWrapper == 'inputTests'){
      function randomArr(arr){
        var newArr = [...arr],
            randInt = 5;
        function randomInteger(min, max) {
          var rand = min - 0.5 + Math.random() * (max - min + 1)
          rand = Math.round(rand);
          return rand;
        }
        randInt = randomInteger(5, 25);

        for(var i = 0, l = randInt; i < l; i++){
          newArr.push(newArr[0]);
          newArr.splice(0, 1);
        }
        return newArr;
      }

      if(this.props.test){
        var test = false;
        
        if(this.props.test.select){
          this.newArr = this.props.test.answers;
        }else{
          this.newArr = randomArr(this.props.test.answers);
        }
      }

      if(this.props.showKeyboardFromTest){
        var helper = '';
        this.newArr.forEach(function(item){
          if(item.customVariant){
            helper = item.name;
          }
        })
      }

      if(this.props.test){
        if(this.props.mobile){
          return(
            <div className={"formWrapper test" + (this.props.error ? ' error' : '')}>
            <div className="header">
              <div className="wrapperTableCol">
                <div className="innerTable">
                <div className="back" onClick={this.handleBack}><i style={{verticalAlign: 'sub', fontSize: 25, position: 'relative', right: 9,}} className="fa fa-angle-left"></i> НАЗАД</div>
                  <PageNumber
                    pageID={this.props.pageID}
                  />
                  <div className="erase" onClick={this.handleTestNext}>ДАЛЕЕ <i style={{verticalAlign: 'sub', fontSize: 25, position: 'relative', left: 9,}} className="fa fa-angle-right"></i></div>
                </div>
              </div>
            </div>
            <div className="headline">
              <div className="namePage" ref={(c) => this.testInputWrapper = c} style={{fontSize: typeof this.props.test.nameSizeM != 'undefined' ? this.props.test.nameSizeM : '28px'}}>
                <div ref={(c) => this.testInput = c} className="textWrapper">{this.props.test.question}</div>
              </div>
            </div>
            <div className="inputWrapper">
              <div className="input"><div className="input" dangerouslySetInnerHTML={{__html: helper}}></div></div>
            </div>
            <div className="variants" style={{fontSize: typeof this.props.test.variantsSizeM != 'undefined' ? this.props.test.variantsSizeM : '28px'}}>
              <div className="table">
              {this.props.showKeyboardFromTest ? (
                <div className="keyboardButton">
                <KeyboardsSwitcher
                  type={'letters3'}
                  actionSaveField={this.actionSaveField}
                  // regexp={}
                  // defaultText={this.props.defaultText}
                  closeKeyboard={this.props.actionSelectCustomVariant}
                  text={helper}
                  actionDoneNext={this.handleDoneNext}
                  autoNext={this.props.autoNext}
                  mobile={this.props.mobile}
                  opperativeKey={this.props.opperativeKey}
                  advertisingSites={this.props.advertisingSites}
                />
                    <input ref={(c) => this._input2 = c} style={{width: '100%', height: '100%', opacity: 0
                    }} type="text" onFocus={function(){
                      // console.log('onFOCUUS1')
                      this.props.focusKeyboard();
                      this._input2.setAttribute("disabled", "disabled");
                    }.bind(this)} />
                </div>
                
              ) : (this.newArr.map((item, i) => {
                if(item.name || item.customVariant){
                  return(
                    <TestVariant
                      key={i}
                      text={item.name}
                      id={item.id}
                      select={typeof item.select != 'undefined' ? item.select : false}
                      actionTestSelect={this.handleTestSelect}
                      customVariant={item.customVariant ? true : false}
                      actionSelectCustomVariant={this.props.actionSelectCustomVariant}
                    />
                  );
                }
              }))}
              </div>
            </div>
          </div>
        );
        }else{
          var countVaraint = 0;
          this.newArr.map((item, i) => {
            if(item.name || item.customVariant){
              countVaraint += 1;
            }
          });
          return(
            <div className={"formWrapper test" + (this.props.error ? ' error' : '')}>
              <div className="header">
                <div className="home" onClick={this.handleHome}><i style={{fontSize: 32, position: 'relative', top: 6}} className="material-icons">&#xe5c3;</i>Главная</div>
                <div className={"namePage " + (this.props.showKeyboardFromTest ? 'CustomVariant' : '')} ref={(c) => this.testInputWrapper = c} style={{fontSize: '32px', overflow: 'hidden'}}><div ref={(c) => this.testInput = c} style={{height: 'auto'}} className="textWrapper">{this.props.test.question}</div></div>
                <Time/>
              </div>
              <div className="inputWrapper">
                <div className="back" onClick={this.handleTestBack}><i style={{fontSize: 40, position: 'relative', top: 5, right: 9,}} className="fa fa-angle-left"></i> НАЗАД</div>
                <div className="input"  ref={(c) => this.inputWrapper = c} style={this.props.showKeyboardFromTest ? {width: 507} : {display: 'none'}}><div ref={(c) => this.input = c} className="input children" dangerouslySetInnerHTML={{__html: helper}}></div></div>

                <div className="erase" onClick={this.handleTestNext}>ДАЛЕЕ <i style={{fontSize: 40, position: 'relative', top: 5, left: 9,}} className="fa fa-angle-right"></i></div>
              </div>
              {this.props.showKeyboardFromTest ? (
                <KeyboardsSwitcher
                    type={'letters3'}
                    actionSaveField={this.actionSaveField}
                    // regexp={}
                    // defaultText={this.props.defaultText}
                    closeKeyboard={this.props.actionSelectCustomVariant}
                    text={helper}
                    actionDoneNext={this.handleDoneNext}
                    autoNext={this.props.autoNext}
                    mobile={this.props.mobile}
                    opperativeKey={this.props.opperativeKey}
                    advertisingSites={this.props.advertisingSites}
                  />
              ) : (
                <div className="variants" style={countVaraint == 4 ? {} : {display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {this.newArr.map((item, i) => {
                  if(item.name || item.customVariant){
                    return(
                      <TestVariant
                        key={i}
                        text={item.name}
                        id={item.id}
                        select={typeof item.select != 'undefined' ? item.select : false}
                        actionTestSelect={this.handleTestSelect}
                        customVariant={item.customVariant ? true : false}
                        actionSelectCustomVariant={this.props.actionSelectCustomVariant}
                      />
                    );
                  }
                })}
              </div>
              )}
            </div>
          );
        }
      }else{
        return null;
      }

    }

  },
  componentWillUpdate: function(nextProps){
    if(nextProps.typeWrapper == 'inputTests' && nextProps.test == null && JSON.stringify(nextProps) != JSON.stringify(this.props)){
      console.log('туту')
      this.props.actionSaveField({nav: 'next'});
    }
  }
});


export default KeyboardWrapper;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/index.jsx
 **/